export default __webpack_public_path__ + "images/574be2941ebdf29e6204315302a25a4b-edm.jpg";